import { render, staticRenderFns } from "./AttendantsComponent.vue?vue&type=template&id=3afa6734&scoped=true"
import script from "./AttendantsComponent.vue?vue&type=script&lang=js"
export * from "./AttendantsComponent.vue?vue&type=script&lang=js"
import style0 from "./AttendantsComponent.vue?vue&type=style&index=0&id=3afa6734&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afa6734",
  null
  
)

export default component.exports